import { GET_NOTIFICATION_SETTINGS } from "../../redux/constants";
import { ApiCall } from "../../utils/index"

export const notificationData = (request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await ApiCall.get(`/notification_setting/byCompanyId`, token);
    dispatch({ type: GET_NOTIFICATION_SETTINGS, payload: result.data[0] });
  } catch (error) {
    request.onError();
  }
};

export const updateNotificationSetting =
  (request) => async (dispath, getState) => {
    try {
      const {
        auth: { token },
      } = getState();
      const result = await ApiCall.patch(`/notification_setting`, request.data, token)
      request.onSuccess()
    } catch (error) {
      request.onError();
    }
  };
